<template>
    <div v-show="showInfoModal" class="full-popup-wrapper">
        <div class="full-popup">
            <div class="map-history-header">
                <div class="mhh-title">Displaying location history for "{{settings.data.assetId == '' ? '<>' : settings.data.assetId}}"</div>
                <div class="close-btn" @click="onCloseClick">Close</div>
            </div>
            <div id="map-location-history" class="map">
                <div class="votes_detailed_main_container collapsed" id="asset_sidebar_history"
                     @click.self="console.log('asset_sidebar click')">
                    <div class="votes_detailed_wrapper">
                        <div class="votes_detailed">
                            <div class="asset_details_id"
                                 v-if="assetSidebar.question && assetSidebar.question.type.type != 'any'"><span
                                class="">{{ assetSidebar.question.type.name }}</span></div>
                            <div class="asset_details_id"><span class="asset_id">{{ assetSidebar.asset_id }}</span>
                                ({{ assetSidebar.question_id }})
                            </div>
                            <div class="asset_details_id" v-if="assetSidebar.question"><span
                                class="">{{ assetSidebar.question.placement }}</span></div>
                            <div class="asset_details_info">Updated on
                                {{ assetSidebar.dateFormatted }}{{ assetSidebar.author }}
                            </div>
                            <div class="votes_detailed_close" @click="closeAssetSidebar">Close</div>
                            <div class="asset_popup_btns">
                                <div class="link_btn" @click="onOpenAssetInGoogleClick">open in Google</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from "vuex";
import mapFunctionsMixin from "@/mixins/mapFunctionsMixin";
import waitForElmMixin from "@/mixins/waitForElmMixin";
import moment from 'moment'

export default {
    name: 'mapLocationHistory',

    mixins: [errorMixin, mapFunctionsMixin, waitForElmMixin],

    data() {
        return {
            showInfoModal: this.settings.show,
            mapBox: {
                firstRenderFinished: false,
                isSatelliteMode: false,
            },
            mapBoxMapBounds: null,
            currentMapBoxHistoryData: {
                type: "FeatureCollection",
                features: [],
            },
            lineLatLngsGeoJson: {},
            lineColor: '#2d5a9e',
            assetSidebar: {
                visible: false,
                dateFormatted: '',
                asset_id: '',
                question_id: null,
                question: null,
                author: '',
                coordinates: {
                    lat: 0,
                    lng: 0,
                },
            },
        }
    },

    watch: {
        settings(newValue) {
            console.log(`mapLocationHistory settings changed:`, newValue)
            this.showInfoModal = this.settings.show
        },
        'settings.show'(newValue) {
            console.log(`mapLocationHistory settings show changed:`, newValue)
            this.showInfoModal = this.settings.show
            if (newValue) {
                let thiz = this
                this.waitForElm('#map-location-history').then((elm) => {
                    console.log('map-location-history is ready');
                    thiz.setupMapBoxMap()
                });
                this.refresh()
            }
        },
        'settings.data'(newValue) {
            console.log(`mapLocationHistory settings data changed:`, newValue)
            if (this.settings.show) {
                this.refresh()
            }
        },
        'mapBox.isSatelliteMode'(newValue) {
            console.log(`mapBox.isSatelliteMode changed: ${newValue}`)
            this.onMapModeChanged(newValue)
        },
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    components: {},

    computed: {
        ...mapState({}),
    },

    mounted() {
        console.log(`mounted mapLocationHistory`)
    },

    methods: {

        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
        }),
        ...mapActions({
            getQuestionsLocationHistoryDashboard: 'question/getQuestionsLocationHistoryDashboard',
        }),

        refresh() {
            if (this.settings.data) {
                // this.currentMapBoxHistoryData = this.settings.data.historyData
                this.fetchLocationHistory()
            }
        },

        setupMapBoxMap() {
            if (this.mapBoxMap) {
                this.mapBoxMap.remove()
            }
            console.log(`setupMapBoxMap`)
            mapboxgl.accessToken = 'pk.eyJ1IjoiYWlydm90ZSIsImEiOiJjbGt2ZzU1M28wazQ1M2ZyMGwxdDN4d3puIn0.a-UUEX4p0wzUz8SSQ6SJ-g';

            const map = new mapboxgl.Map({
                container: 'map-location-history',
                zoom: 0.3,
                center: [0, 20],
                style: this.getMapBoxStyle(),
                projection: 'mercator',
                maxZoom: 22,
            });
            this.mapBoxMap = map
            let thiz = this

            class MapModeControl {
                onAdd(map) {
                    this.map = map;
                    this.container = document.createElement('div');
                    let classMode = thiz.mapBox.isSatelliteMode ? 'default' : 'satellite'
                    this.container.className = `mapboxgl-ctrl mapboxgl-ctrl-group map-mode-btn-h ${classMode}`;
                    this.container.id = 'map_mode_btn_h';
                    this.container.addEventListener("click", () => {
                        console.log(`onChangeMapModeClick history`)
                        thiz.onChangeMapModeClick()
                    });
                    return this.container;
                }

                onRemove() {
                    this.container.parentNode.removeChild(this.container);
                    this.map = undefined;
                }
            }

            document.querySelectorAll(".map-mode-btn-h").forEach(el => el.remove());
            const mapModeControl = new MapModeControl();
            map.addControl(new mapboxgl.NavigationControl());
            map.addControl(new mapboxgl.FullscreenControl());
            map.addControl(mapModeControl);

            const typeAny = ['==', ['get', 't'], 0];
            const typePortableToilet = ['==', ['get', 't'], 1];
            const typeTrailer = ['==', ['get', 't'], 2];
            const typeTrailerStall = ['==', ['get', 't'], 3];
            const typeGreasetrap = ['==', ['get', 't'], 4];
            const typeInterceptor = ['==', ['get', 't'], 5];
            const typeDumpster = ['==', ['get', 't'], 6];
            const typeSink = ['==', ['get', 't'], 7];
            const typeTank = ['==', ['get', 't'], 8];
            const typeVending = ['==', ['get', 't'], 9];
            const typeRestroom = ['==', ['get', 't'], 10];
            const typeRestroomStall = ['==', ['get', 't'], 11];
            const typeTable = ['==', ['get', 't'], 12];
            const typeShower = ['==', ['get', 't'], 13];

            loadImages()
            map.on('load', () => {
                map.on('mouseenter', `asset_item_lbl`, () => {
                    map.getCanvas().style.cursor = 'pointer';
                });
                map.on('mouseleave', `asset_item_lbl`, () => {
                    map.getCanvas().style.cursor = '';
                });

                map.on('click', 'asset_item_lbl', (e) => {
                    console.log(`asset_item_lbl click`, e)
                    if (e.originalEvent.clickOnLayer) {
                        return;
                    }
                    // this.showAssetSidebar(e.features[0])
                });
                console.log(`MAP LOADED`)
                map.resize()
                setupMap()

                map.on('render', () => {
                    if (!thiz.mapBox.firstRenderFinished) {
                        thiz.mapBox.firstRenderFinished = true
                        thiz.fitMapToMarkersBounds()
                    }
                });
            });
            map.on('style.load', () => {
                console.log(`on styledata called!!!!!!!!!!!!!!`)
                if (!map.getSource('line')) {
                    console.log(`on styledata  call setupMap`)
                    setupMap()
                }
            })

            function setupMap() {
                console.log(`setupMap`)
                loadImages()
                // ___
                // if(!map.getSource('assets_points')) {
                //     map.addSource('assets_points', {
                //         'type': 'geojson',
                //         'data': thiz.currentMapBoxHistoryData,
                //         'cluster': false,
                //         'clusterRadius': 50,
                //         'clusterMaxZoom': 18,
                //     });
                // }
                if (!map.getSource('line')) {
                    console.log(`adding source 'line':`, thiz.lineLatLngsGeoJson)
                    map.addSource('line', {
                        'type': 'geojson',
                        'data': thiz.lineLatLngsGeoJson,
                    });
                }
                if (!map.getLayer('line')) {
                    console.log(`adding layer 'line'`)
                    map.addLayer({
                        'id': 'line',
                        'type': 'line',
                        'source': 'line',
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round',
                        },
                        'paint': {
                            'line-color': thiz.lineColor,
                            'line-width': 2,
                            'line-translate': [0, 23.0],
                        }
                    });
                }
                // if(!map.getLayer('asset_item_lbl')) {
                //     map.addLayer({
                //         'id': 'asset_item_lbl',
                //         'type': 'symbol',
                //         // 'icon-allow-overlap': true,
                //         // 'text-allow-overlap': true,
                //         "icon-allow-overlap": true,
                //         "icon-ignore-placement": true,
                //         "text-allow-overlap": true,
                //         "text-ignore-placement": true,
                //         'source': 'assets_points',
                //         'filter': ['!=', 'cluster', true],
                //         'layout': {
                //             'icon-image': ['case',
                //                 typeDumpster,
                //                 'dumpster_lbl',
                //                 typeGreasetrap,
                //                 'greasetrap_lbl',
                //                 typeSink,
                //                 'handwash_lbl',
                //                 typeTrailer,
                //                 'trailer_lbl',
                //                 typeTank,
                //                 'tank_lbl',
                //                 typeInterceptor,
                //                 'greasetrap_lbl',
                //                 typePortableToilet,
                //                 'asset_blue_lbl',
                //                 'generic_lbl',],
                //             'icon-text-fit': 'both',
                //             // 'icon-size': 0.3,
                //             // 'icon-anchor': 'bottom',
                //             'text-field': [
                //                 'format',
                //                 // ['image', 'asset_blue_lbl'],
                //                 // '\n',
                //                 // ['literal', 'sdfasd'],
                //                 ['get', 'started_at'],
                //                 // ['literal', 'sdfasd']
                //             ],
                //             'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                //             'text-size': 13,
                //             'text-anchor': 'center',
                //             'text-offset': [0, -5.5],
                //         },
                //         // paint: {
                //         //     "text-color": "#000000",
                //         //     "text-halo-color": "#2D59A2",
                //         //     "text-halo-width": 2,
                //         // }
                //     });
                // }
            }

            function loadImages() {
                thiz.loadMapImages(map, true)
            }
        },

        async fetchLocationHistory() {
            let questionId = this.settings.data.questionId
            let assetId = this.settings.data.assetId
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'load history'
                })
                this.loadingAction = true
                const response = await this.getQuestionsLocationHistoryDashboard({question_id: questionId})
                let items = response.items
                let historyItemsCount = items.length
                let geoJsonItems = []
                let lineItems = []
                if (historyItemsCount > 1) {
                    items.forEach((item) => {
                        geoJsonItems.push({
                            geometry: {type: "Point", coordinates: [item.latlng.lng, item.latlng.lat]},
                            properties: {
                                q: item.q_id,
                                s: item.s,
                                t: item.t,
                                i: item.i,
                                started_at: item.started_at,
                                finished_at: item.finished_at,
                            },
                            type: "Feature"
                        })
                        lineItems.push([item.latlng.lng, item.latlng.lat])
                    })
                    var bounds = lineItems.reduce(function (bounds, item) {
                        return bounds.extend(item);
                    }, new mapboxgl.LngLatBounds(lineItems[0], lineItems[0]));
                    this.mapBoxMapBounds = bounds
                    this.fitMapToMarkersBounds()

                    this.lineLatLngsGeoJson = {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: lineItems,
                        },
                    }
                    this.mapBoxMap.getSource('line').setData(this.lineLatLngsGeoJson)
                    this.currentMapBoxHistoryData = {
                        type: "FeatureCollection",
                        features: geoJsonItems,
                    }
                    console.log(`geoJsonItems:`, geoJsonItems)
                    // if(this.mapBoxMap && this.mapBoxMap.getSource('assets_points')) {
                    //     this.mapBoxMap.getSource('assets_points').setData(this.currentMapBoxHistoryData)
                    //     // this.setupMapBoxMap()
                    //     console.log('items loaded and set to the map')
                    // } else {
                    //     console.log('items loaded but not set to the map')
                    // }
                    let mapBoxMap = this.mapBoxMap

                    let thiz = this
                    geoJsonItems.forEach(function (marker) {
                        let properties = marker.properties
                        var imgData = thiz.getMarkerImageData(properties, properties.i && !properties.i.fixed)
                        thiz.lineColor = imgData.color
                        mapBoxMap.setPaintProperty('line', 'line-color', imgData.color);
                        console.log(`imgData:`, imgData)
                        let img = require(`@/assets/icons/${imgData.imgName}.png`)


                        var el = document.createElement('div');
                        let backgroundColor = properties.finished_at == null ? imgData.color : 'white'
                        el.innerHTML = `<div class="asset_marker_wrapper"><img class="asset_marker_img" src="${img}"/><div class="asset_marker_lbl ${properties.finished_at == null ? 'current' : ''}"  style="border-color: ${imgData.color}; background-color: ${backgroundColor};">${moment(properties.started_at * 1000).format("MMM D YYYY, h:mm a")}</div></div>`
                        console.log(`_marker.finished_at: ${properties.finished_at}`)

                        el.onclick = function () {
                            thiz.showAssetSidebar(marker)
                        };

                        new mapboxgl.Marker(el)
                            .setLngLat(marker.geometry.coordinates)
                            .addTo(mapBoxMap);
                    });
                } else {
                    let name = assetId == '' || assetId == '<>' ? 'This asset' : `Asset "${assetId}"`
                    this.showErrorModal(`${name} doesn't have elder locations`, {duration: 2200})
                }
            } catch (e) {
                console.log(e)
                // this.historyView.showHistory = false
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'load history'
                })
            }
        },
        getMarkerImageData(c, hasIssue) {
            var imgName = 'ic_qmarker_generic_lbl'
            let color = '#045451'
            switch (c.t) {
                case 1: {
                    imgName = 'ic_qmarker_asset_lbl'
                    color = '#2d5a9e'
                    break
                }
                case 2: {
                    imgName = 'ic_qmarker_trailer_lbl'
                    color = '#00677a'
                    break
                }
                case 4: {
                    imgName = 'ic_qmarker_greasetrap_lbl'
                    color = '#000000'
                    break
                }
                case 5: { //interceptor
                    imgName = 'ic_qmarker_greasetrap_lbl'
                    color = '#000000'
                    break
                }
                case 6: {
                    imgName = 'ic_qmarker_dumpster_lbl'
                    color = '#4a9e34'
                    break
                }
                case 7: {
                    imgName = 'ic_qmarker_handwash_lbl'
                    color = '#937902'
                    break
                }
                case 8: {
                    imgName = 'ic_qmarker_tank_lbl'
                    color = '#00065a'
                    break
                }
                default: {

                }
            }
            if (hasIssue) {
                imgName += '_issue'
            }
            return {imgName: imgName, color: color}
        },

        async onCloseClick() {
            // console.log(`has mapBoxMap`, this.mapBoxMap.getStyle().layers)
            // return
            this.clearAllData()
            this.settings.show = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },
        clearAllData() {
            this.closeAssetSidebar()
            this.lineLatLngsGeoJson = []
            this.currentMapBoxHistoryData = {
                type: "FeatureCollection",
                features: [],
            }
        },

        async onOk() {
            this.showInfoModal = false
            if (this.settings.onOkHandler) {
                try {
                    await this.settings.onOkHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },

        onAdditional() {
            this.showInfoModal = false
            if (this.settings.onAdditionalHandler) {
                this.settings.onAdditionalHandler(this.settings)
            }
        },

        getMapBoxStyle() {
            return this.mapBox.isSatelliteMode ? 'mapbox://styles/mapbox/satellite-v9' : 'mapbox://styles/mapbox/streets-v12'
        },
        onChangeMapModeClick() {
            this.mapBox.isSatelliteMode = !this.mapBox.isSatelliteMode
        },
        fitMapToMarkersBounds() {
            if (this.mapBoxMap && this.mapBoxMapBounds) {
                this.mapBoxMap.resize()
                this.mapBoxMap.fitBounds(this.mapBoxMapBounds, {
                    padding: 80,
                });
            }
        },
        onMapModeChanged(isSatellite) {
            if (this.mapBoxMap) {
                let style = this.getMapBoxStyle()
                this.mapBoxMap.setStyle(style)
            }
            let mapModeBtns = document.getElementsByClassName('map-mode-btn-h')
            if (mapModeBtns) {
                let classMode = this.mapBox.isSatelliteMode ? 'default' : 'satellite'
                mapModeBtns.forEach(item => {
                    item.classList.remove('satellite')
                    item.classList.remove('default')
                    item.classList.add(classMode)
                })
            }
        },
        async showAssetSidebar(feature) {
            console.log('showAssetSidebar:', feature)

            const coordinates = feature.geometry.coordinates.slice();
            let properties = feature.properties

            let date = moment(properties.started_at * 1000).format("MMM D YYYY, h:mm a")
            this.assetSidebar.dateFormatted = date
            let author = properties.s != '' ? ` by ${properties.s}` : ''
            this.assetSidebar.author = author
            this.assetSidebar.asset_id = properties.a_id
            this.assetSidebar.question_id = properties.q
            this.assetSidebar.coordinates.lat = coordinates[1]
            this.assetSidebar.coordinates.lng = coordinates[0]

            this.assetSidebar.visible = true
            const elem = document.getElementById('asset_sidebar_history');
            elem.classList.remove('collapsed')
        },
        onAssetSidebarCloseClick() {
            this.closeAssetSidebar()
        },
        closeAssetSidebar() {
            // this.setMapLeftPadding(0)
            this.assetSidebar.question = null
            this.assetSidebar.visible = false
            const elem = document.getElementById('asset_sidebar_history');
            elem.classList.add('collapsed')
        },
        onOpenAssetInGoogleClick() {
            let lat = this.assetSidebar.coordinates.lat
            let lng = this.assetSidebar.coordinates.lng
            window.open(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},17z`, '_blank').focus();
        },


    },
}
</script>

<style>
.map-mode-btn-h {
    width: 30px;
    height: 30px;
    background: green;
    border-radius: 4px;
    margin-right: 8px;
    cursor: pointer;
    background-size: 30px;
}

.map-mode-btn-h.satellite {
    background: url('../../assets/icons/img_map_satellite.png') no-repeat;
    background-size: 30px;
}

.map-mode-btn-h.default {
    background: url('../../assets/icons/img_map_default.png') no-repeat;
    background-size: 30px;
}

.marker-pom {
    width: 30px;
    height: 30px;
    background: red;
}
</style>
<style scoped>
.map-history-header {

}
.mhh-title {
    width: 100%;
    align-content: center;
    text-align: center;
    height: 40px;
}
.full-popup-wrapper {
    background: rgba(0, 0, 0, 0.56);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
    z-index: 9999999999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.full-popup {
    position: absolute;
    top: 20px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    background: white;
    display: flex;
    flex-direction: column;
}

.close-btn {
    position: absolute;
    z-index: 99999;
    width: 76px;
    height: 40px;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #054e71;
    right: 0;
    top: 0;
}

.close-btn:hover {
    text-decoration: underline;
}

.map {
    width: 100%;
    height: 100%;
    z-index: 99;
}


</style>
